// @ts-nocheck
import { getFirstInputInError } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

export default (formId: string) => {
    return useSelector((state: ApplicationState) => getFirstInputInError(state, formId));
};
